import { Typography } from "@lyfegen-platform/react-common";
import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { TableTypes } from "./LyfeDataTable";
import LyfePagination from "./LyfePagination";

interface ITableBottomDrawer {
	title: TableTypes;
	totalRecords: number;
	filteredRecords: number;
	selectedRecords?: number;
	pageSizeOptions?: Array<number>;
}

const TableBottomDrawer = (props: ITableBottomDrawer) => {
	const { t } = useTranslation();
	const canShowSelected = (props.selectedRecords && props.selectedRecords > 0) || false;

	return (
		<>
			<Box width="100%" display="flex" justifyContent="flex-start">
				<Box p={1} display="flex" alignItems="center" alignSelf="flex-start">
					<Typography variant="body2">
						{props.totalRecords || 0} {props.totalRecords === 1 ? t(`${props.title}-singular`) : t(props.title)} {t("in-total")}
					</Typography>
					&nbsp;
					{props.filteredRecords < props.totalRecords && (
						<Typography variant="body2">
							| {props.filteredRecords} {props.filteredRecords === 1 ? t(`${props.title}-singular`) : t(props.title)}{" "}
							{t("filtered-entity")}
						</Typography>
					)}
					&nbsp;
					{canShowSelected && (
						<Typography variant="body2">
							| {props.selectedRecords} {props.selectedRecords === 1 ? t(`${props.title}-singular`) : t(props.title)}{" "}
							{t("selected")}
						</Typography>
					)}
				</Box>
			</Box>
			{props.pageSizeOptions && (
				<Box width="100%" display="flex" justifyContent="flex-end">
					<LyfePagination count={props.filteredRecords || 0} pageSizeOptions={props.pageSizeOptions} title={props.title} />
				</Box>
			)}
		</>
	);
};

export default TableBottomDrawer;
